export default __webpack_public_path__ + "static/media/editor.7bf31cbc.png";